import React from 'react'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import usePageContext from '../../../hooks/usePageContext'
import { TextWitListItemProps } from '../../organisms/TextWithList/types'
import TextWithListSection from '../../sections/TextWithListSection'
import { NumberedListSliceProps } from './types'
import { mapButtonProps } from '../../atoms/Button/utils'

const NumberedListSlice: React.FC<NumberedListSliceProps> = ({ slice }) => {
  const {
    align_left,
    full_width,
    heading,
    is_main_heading,
    background_color,
    nl_button_text,
    nl_button_type,
    nl_button_is_centered,
    nl_button_caption,
    nl_button_caption_mobile_size,
    nl_button_caption_desktop_size,
    nl_button_link,
    nl_items_per_row,
    nl_items_description
  } = slice.primary || {}
  const { group } = usePageContext()

  const data: TextWitListItemProps = {
    title: slice.primary?.title?.text,
    subtitle: slice.primary?.subtitle?.text,
    content: slice.primary?.description?.html,
    isAlignLeft: align_left,
    cta: mapButtonProps(
      nl_button_type,
      nl_button_text,
      resolvePrismicLink(nl_button_link, group),
      nl_button_link?.link_type,
      nl_button_caption,
      nl_button_caption_mobile_size,
      nl_button_caption_desktop_size,
      nl_button_is_centered
    ),
    description: nl_items_description,
    listData: {
      itemsPerRow: nl_items_per_row || slice.items?.length || 0,
      list:
        slice.items?.map((item) => ({
          number: item?.number || '',
          numberAltFont: item?.is_number_alt,
          currency: item?.currency,
          title: item?.heading?.text,
          caption: item?.title?.text,
          isAlt: item?.is_alt,
          isHorizontal: item?.is_horizontal
        })) || []
    }
  }

  return (
    <TextWithListSection
      id={slice.id}
      inner={full_width ? 'inners.fullWidth' : 'inners.primary'}
      paddingTop={['64px', '168px', '']}
      paddingBottom={['64px', '', '140px']}
      headingPadding={heading?.text ? ['0', '', '0px'] : ['38px', '114px', '']}
      heading={heading?.text}
      isMainHeading={is_main_heading}
      bgColor={background_color}
      data={data}
    />
  )
}

export default NumberedListSlice
